<template>
  <div style="width: 100%;height: 100%;">
    <el-container style="height: 100%;" v-if="$route.meta.keepalive">
      <el-container style="padding-top: 0px; height: 100%;">
        <el-main style="padding: 0px;">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
    <router-view v-if="!$route.meta.keepalive"></router-view>
  </div>
</template>

<script>
import templateEdit from "./components/templateEdit"

export default {
  name: 'App',
  components: {
    'v_main': templateEdit
  }
}
</script>

<style>
body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue